import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '@app/@core/local-storage/local-storage.service';
import { AlertService } from '@app/@core/services/alert.service';
import { AppService } from '@app/@core/services/app.service';
import { AuthService } from '@app/@core/services/auth.service';
import { HttpService } from '@app/@core/services/http.service';
import { SharedService } from '@app/@core/services/shared.service';
import { LocalService } from '@core/services/local.service';
import { DxDataGridComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import * as jsPDF from 'jspdf';
import * as moment from 'moment';
import { GridListService } from './grid-list.service';
import { InAppNotificationService } from '@pics-core/common-utils';
const SELECT_ALL = 'Select-ALL';
@Component({
  standalone: false,
  selector: 'app-grid-list',
  providers: [GridListService],
  templateUrl: './grid-list.component.html',
  styleUrls: ['./grid-list.component.scss']
})
export class GridListComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid!: DxDataGridComponent;
  @ViewChildren('contentWrapper') contentWrappers: QueryList<ElementRef>;
  @Input() dataList: any[];
  @Input() dataSource: DataSource;
  @Input() columns: any;
  @Input() updateGrid: any;
  @Input() totalCount: number;
  @Input() page: number;
  @Input() isShow: any;
  @Input() exportPageName: string;
  @Input() remoteOperations: boolean;
  @Output() currentPage = new EventEmitter<number>();
  @Output() editTableRow = new EventEmitter<any>();
  @Output() viewTableRow = new EventEmitter<any>();
  @Output() deleteTableRow = new EventEmitter<any>();
  @Output() openExternalLink = new EventEmitter<any>();
  @Output() openpopupLink = new EventEmitter<any>();
  @Output() routeTo = new EventEmitter<any>();
  @Output() openPopup = new EventEmitter<any>();
  @Output() sortOrder = new EventEmitter<any>();
  @Output() filterSearchValue = new EventEmitter<any>();
  @Output() filterBuilderPopup = new EventEmitter<any>();
  @Output() filterPanel = new EventEmitter<any>();
  @Output() multipleFilterValues = new EventEmitter<any>();
  @Output() downloadTableRow = new EventEmitter<any>();
  @Output() rowSelection = new EventEmitter<any>();
  @Output() toggleRow = new EventEmitter<any>();
  @Output() duplicateRow = new EventEmitter<any>();
  @Output() viewVersions = new EventEmitter<any>();
  @Output() activateVersion = new EventEmitter<any>();
  @Output() activatePage = new EventEmitter<any>();
  @Output() deactivatePage = new EventEmitter<any>();
  @Output() duplicatePageVersion = new EventEmitter<any>();
  @Output() selectedRowsData = new EventEmitter<any>();
  orgList: any;
  dataField: string[];
  columnHeader: any[];
  popupPosition: any;
  filterValue: (string | string[])[];
  customOperations: any[];
  fields: any;
  customStore: any;
  tempColumns: any[];
  Organization: any;
  dUrl: string;
  rdUrl: string;
  rUrl: any;
  user: any;
  userId: number;
  tempList: any[];
  showVersions: boolean;
  displayMode: any;
  registrationInfo: any;
  activepagename: any;
  url: any;
  oldUrl: any;
  alertService: any;
  sharedService: any;
  mainNotificationService: any;
  localstorage: LocalService;
  httpService: HttpService;
  storageService: LocalStorageService;
  appService: AppService;
  auth: AuthService;
  constructor(
    injector: Injector,
    private router: Router,
    private renderer: Renderer2,
  ) {
    this.alertService = injector.get<AlertService>(AlertService);
    this.sharedService = injector.get<SharedService>(SharedService);
    this.mainNotificationService = injector.get<InAppNotificationService>(InAppNotificationService);
    this.httpService = injector.get<HttpService>(HttpService);
    this.localstorage = injector.get<LocalService>(LocalService);
    this.storageService = injector.get<LocalStorageService>(LocalStorageService);
    this.appService = injector.get<AppService>(AppService);
    this.auth = injector.get<AuthService>(AuthService);
    this.showVersions = false;
    this.loadGWithParam();
    this.user = this.localstorage.getObj('user');
    this.userId = this.localstorage.getItem('id');
    this.rUrl = this.router.url.split('/');
    if (this.rUrl.includes('versions')) {
      this.showVersions = true;
    }
    this.displayMode = 'compact';
  }

  ngOnInit() {
    if (this.isShow === false) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }

    this.tempColumns = this.columns;
    if (this.columns && this.columns.gridConfigFormArray) {
      this.columnHeader = this.columns.gridConfigFormArray.map(column => column.header);
      this.columns = this.columns.gridConfigFormArray;
    } else {
      this.columnHeader = this.columns.map(column => column.header);
    }
    this.popupPosition = { of: window, at: 'top', my: 'top', offset: { y: 10 } };
    this.filterValue = [];
    this.customOperations = [];
  }

  ngOnChanges() {
    this.loadGWithParam();
  }

  loadGWithParam() {
    this.tempList = this.dataList;
    if (this.tempList) {
      const name = this.tempList.filter(item => item.isactive);
      if (name.length > 0) {
        this.activepagename = name[0].pagename;
      }
    }
    if (!this.auth.isAdmin()) {
      this.loadGrid({ value: !this.Organization ? this.auth.getOrgID() : this.Organization }, false);
    } else {
      this.loadGrid({ value: this.Organization ? this.Organization : SELECT_ALL }, false);
    }
  }

  ngAfterViewInit() {
    this.dataGrid.onOptionChanged.subscribe(e => {
      if (e.name === 'columns' && e.fullName.endsWith('filterValues')) {
        const colIndex = Number(
          e.fullName
            .match(/\[\d+\]/)[0]
            .replace('[', '')
            .replace(']', '')
        );
        const values = e.component.columnOption(colIndex, 'filterValues');
        console.log(values);
        this.multipleFilterValues.emit(e);
      }

      // Search
      if (e.name === 'columns' && e.fullName.endsWith('filterValue')) {
        console.log(e);
        this.filterSearchValue.emit(e);
      }

      // filter Builder Popup

      if (e.name === 'filterBuilderPopup') {
        console.log('filterBuilderPopup');
        console.log(e);
        this.filterBuilderPopup.emit(e);
      }

      // filter Panel - enable or disable
      if (e.name === 'filterPanel') {
        console.log(e.value);
        this.filterPanel.emit(e);
      }

      // Sorting
      if (e.name === 'columns' && e.fullName.endsWith('sortOrder')) {
        this.sortOrder.emit(e);
      }

      // Paging
      if (e.name === 'paging') {
        this.currentPage.emit(e.value);
      }
    });
    const REGISTRATION = this.storageService.getItem('REGISTRATION');
    if (REGISTRATION) {
      this.registrationInfo = JSON.parse(REGISTRATION);
    }

    this.contentWrappers.changes.subscribe((comps: QueryList<ElementRef>) => {
      comps.forEach(wrapper => {
        this.applyLinkStyles(wrapper);
      });
    });
  }

  private applyLinkStyles(wrapper: ElementRef) {
    const anchors = wrapper.nativeElement.querySelectorAll('a');
    anchors.forEach(anchor => {
      this.renderer.setStyle(anchor, 'color', '#0049E5');
      this.renderer.listen(anchor, 'mouseenter', () => {
        this.renderer.setStyle(anchor, 'opacity', '0.5');
      });
      this.renderer.listen(anchor, 'mouseleave', () => {
        this.renderer.setStyle(anchor, 'opacity', '1');
      });
    });
  }

  loadGrid(orgID, load = true) {
    this.Organization = orgID.value;
    if (load) {
      this.currentPage.emit(orgID.value === SELECT_ALL ? 'all' : orgID.value);
    }

    if (this.tempList && this.tempList.length) {
      this.tempGridList(orgID);
    } else {
      this.customStore = this.dataSource;
    }
  }
  tempGridList(orgID) {
    if (orgID && orgID.value) {
      this.splitGridList(orgID);
    }
    if (this.dataList.length === 1 && this.rUrl && this.rUrl[2] === 'view-dashboard') {
      this.dUrl = 'view-dashboard/dashboard';
      this.router.navigateByUrl(`pages/${this.dUrl}/${this.dataList[0]['id']}`);
    }
    // Quick change
    this.customStore = new CustomStore({
      load: _opts => Promise.resolve(this.dataList),
      totalCount: _opts => Promise.resolve(this.totalCount)
    });
  }
  splitGridList(orgID) {
    this.dataList = this.tempList.filter(data => data.organizationid);
    this.dataList = this.tempList.filter(data => data.organizationid === orgID.value);
    if (this.tempList && this.tempList.length && this.tempList[0].displayname && this.tempList[0].userworkinfo) {
      this.dataList = this.tempList.filter(
        data => data.userworkinfo && data.userworkinfo[0] && data.userworkinfo[0].organizationid
      );
      this.dataList = this.tempList.filter(
        data => data.userworkinfo && data.userworkinfo[0] && data.userworkinfo[0].organizationid === orgID.value
      );
    }
    if (SELECT_ALL === orgID.value) {
      this.dataList = this.tempList;
    }
  }

  getRouter(data) {
    this.routeTo.emit(data);
  }

  navigateLink(event: MouseEvent, rowData: any) {
    const target = event.target as HTMLAnchorElement;
    if (target.tagName === 'A' && target.href) {
      this.updateNotificationView(rowData);
      this.url = this.extractUrl(target.outerHTML);
      this.oldUrl = this.extractUrl(target.outerHTML);
      const activeId = this.extractID(this.url.split('?')[0]);
      const isNumberCheck = Number(activeId);
      const urlParams = new URLSearchParams(this.url.split('?')[1]);
      const pageID = urlParams.get('pageID');
      event.preventDefault();
      if (pageID) {
        this.mainNotificationService.checkPageAccessForUser(pageID).subscribe((res: any) => {
          if (res['data']) {
            this.checkPageId(isNumberCheck, activeId, event);
          } else {
            event.preventDefault();
            this.alertService.error("Page Not Available: You don't have the necessary permissions to view this page.");
          }
        }, (_error) => {
          event.preventDefault();
          this.alertService.error("An error occurred while checking page access.");
        });
      } else {
        event.preventDefault();
        this.alertService.error("Page Not Available");
      }
    }
  }

  async checkPageId(isNumberCheck, activeId, event) {
    if (isNumberCheck) {
      const menus = this.localstorage.getObj('MENU');
      const findMenu = menus.find(item => item.name === 'Pages');
      const isExists = findMenu.submenu.find(item => item.id == isNumberCheck);
      if (isExists) {
        this.url = this.url.replace(activeId, isExists.activeVersion.pageid);
        this.url = this.url.split('?')[0];
        this.routeFunction(isNumberCheck, activeId, event, 'mainMenuWithId');
      } else {
        this.routeFunction(isNumberCheck, activeId, event, 'Pages');
      }
    } else {
      this.routeFunction(isNumberCheck, activeId, event, 'mainMenuWithURL');
    }
  }

  routeFunction(isNumberCheck, activeId, event, _menuType) {
    const menus = this.localstorage.getObj('MENU');
    const mainMenu = menus.find(item => item.route === this.url);
    const mainMenuWithUrl = menus.find(element => this.url.endsWith(element.route));
    if (mainMenuWithUrl) {
      this.appService.addValue('CurrentPages', mainMenuWithUrl);
      this.auth.getCurrentMenu(menus);
    } else if (mainMenu) {
      menus.forEach(element => {
        if (element.name === mainMenu.name) {
          element.active = true;
        } else {
          element.active = false;
        }
      });
      if (isNumberCheck) {
        this.appService.addValue('dynamicPages', mainMenu);
        this.auth.getCurrentMenu(menus);
      } else {
        this.appService.addValue('currentPages', mainMenu);
        this.auth.getCurrentMenu(menus);
      }
    } else {
      menus.forEach((element, index) => {
        if (element.submenu.length > 0) {
          element.submenu.forEach((element1, index1) => {
            if (
              element1?.route == this.url ||
              element1?.activeVersion?.pageid == activeId ||
              element1?.activeVersion?.id == activeId
            ) {
              this.setActive(menus, index, index1, isNumberCheck);
            }
          });
        }
      });
    }
    this.router.navigateByUrl(this.oldUrl);
    event.preventDefault();
  }

  setActive(menus: any, menuIndex, submenuIndex, isNumberCheck) {
    menus.map(item => (item.active = false));
    menus.forEach(element => {
      element.submenu.map(item => (item.active = false));
    });
    if (menuIndex) {
      menus[menuIndex].active = true;
      if (submenuIndex >= 0) {
        menus[menuIndex].submenu[submenuIndex].active = true;
      } else {
        menus[menuIndex].active = true;
      }
    } else {
      menus[0].active = true;
    }
    if (isNumberCheck) {
      this.appService.addValue('dynamicPages', menus[menuIndex]);
      this.auth.getCurrentMenu(menus);
    } else {
      this.appService.addValue('currentPages', menus[menuIndex]);
      this.auth.getCurrentMenu(menus);
    }
  }

  extractID(url: string) {
    const parts = url.split('/');
    const lastIndex = parts.length - 1;
    return parts[lastIndex];
  }

  extractUrl(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const link = doc.querySelector('a');
    return link ? link.getAttribute('href') : '';
  }

  popup(data) {
    this.openPopup.emit(data);
  }

  downloadData(evt) {
    this.downloadTableRow.emit(evt);
  }

  onSelectionChanged(evt) {
    this.rowSelection.emit(evt);
  }

  editData(evt) {
    this.editTableRow.emit(evt);
  }
  viewData(evt) {
    this.viewTableRow.emit(evt);
  }
  viewVersion(evt) {
    this.viewVersions.emit(evt);
  }

  activatePageVersion(evt) {
    this.activateVersion.emit(evt);
  }

  activatePages(evt) {
    this.activatePage.emit(evt);
  }
  deactivatePages(evt) {
    this.deactivatePage.emit(evt);
  }
  deleteData(evt) {
    this.deleteTableRow.emit(evt);
  }
  openLink(evt) {
    this.openExternalLink.emit(evt);
  }
  openPopupLink(evt) {
    this.openpopupLink.emit(evt);
  }
  activeUser(evt) {
    this.toggleRow.emit(evt);
  }
  duplicateDate(evt) {
    this.duplicateRow.emit(evt);
  }
  duplicateVersion(evt) {
    this.duplicatePageVersion.emit(evt);
  }

  getOrgList() {
    this.httpService.get('/platform/page-designer/page/organization/all').subscribe((data: any) => {
      if (data.data && data.data.length) {
        this.orgList = data.data.sort((a, b) => a.organizationname?.localeCompare(b.organizationname));
      } else {
        this.orgList = [];
      }
    });
  }

  onRowPrepared(e) {
    if (e.rowType === 'data') {
      e.columns.forEach((column, index) => {
        if (column.caption === 'Date') {
          e.rowElement.cells[index].classList.add('message-new');
        }
      });

      if (e.data.isnew) {
        const element = e.rowElement;
        element.classList.add('isnew');
        e.columns.forEach((column, index) => {
          if (column.caption === 'Date') {
            e.rowElement.cells[index].classList.add('new-icon');
          }
        });
      }
    }
  }

  onCellPrepared(e) {
    if (e.rowType == 'data' && e.data.isactive) {
      if (e.column.dataField === 'version') {
        const element = e.cellElement;
        const livetext = document.createElement('div');
        element.classList.add('live-td');
        livetext.classList.add('live-group');
        livetext.innerHTML = '<div class="live-text">Live</div>';
        element.appendChild(livetext);
      } else if (e.column.dataField === 'templatename') {
        this.exportPageName = e.value.includes('_') ? e.value.split('_')[0] : e.value;
      }
    }
    const maxLength = 60;
    if (e.rowType === 'data' && e.column.dataField === 'message') {
        const element = e.cellElement;
        element.classList.add('truncateWrapper');

        const cell = document.querySelector('.truncateWrapper');
        let cellWidth;
        if (cell) {
          cellWidth = (cell as HTMLElement).offsetWidth;
        }
        // Create a div element for truncation
        const textContent = document.createElement('div');
        textContent.classList.add('text-content');
        textContent.style.maxWidth = `${cellWidth + 15}px`;
        textContent.style.overflow = 'hidden';
        textContent.style.whiteSpace = 'normal';

        // Function to truncate HTML content
        const truncateHtml = (html: string, length: number): string => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          let truncatedHtml = '';
          let currentLength = 0;

          const traverse = (node: Node) => {
            if (node.nodeType === Node.TEXT_NODE) {
              const text = node.textContent || '';
              if (currentLength + text.length > length) {
                truncatedHtml += text.substring(0, length - currentLength) + '...';
                currentLength = length;
                return;
              } else {
                truncatedHtml += text;
                currentLength += text.length;
              }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
              const htmlElement = node as HTMLElement;
              truncatedHtml += `<${htmlElement.tagName.toLowerCase()}`;
              Array.from(htmlElement.attributes).forEach(attr => {
                truncatedHtml += ` ${attr.name}="${attr.value}"`;
              });
              truncatedHtml += '>';
              Array.from(htmlElement.childNodes).forEach(child => traverse(child));
              truncatedHtml += `</${htmlElement.tagName.toLowerCase()}>`;
            }
          };
          Array.from(tempDiv.childNodes).forEach(node => traverse(node));
          return truncatedHtml;
        };

        // Set initial truncated HTML
        textContent.innerHTML = truncateHtml(e.text, maxLength);

        // Create the 'Show More' link
        const showMoreLink = document.createElement('a');
        showMoreLink.href = 'javascript:;';
        showMoreLink.classList.add('showtext');
        showMoreLink.innerText = 'Show More';

        // Create a container div for text and link
        const truncateContainer = document.createElement('div');
        truncateContainer.classList.add('text-truncate');
        truncateContainer.appendChild(textContent);
        truncateContainer.appendChild(showMoreLink);

        // Function to extract plain text from HTML
        const extractPlainTextFromHtml = (html: string): string => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          return tempDiv.textContent || '';
        };

        // Append the container to the cell element
        element.appendChild(truncateContainer);

        // Check if plain text length exceeds the maximum length
        const plainText = extractPlainTextFromHtml(e.text);
        if (plainText.length > maxLength) {
          // Display the 'Show More' link
          showMoreLink.style.display = 'inline';
        } else {
          // Hide the 'Show More' link if not needed
          showMoreLink.style.display = 'none';
        }

        // Handle the 'Show More' link click event
        showMoreLink.addEventListener('click', function () {
          if (textContent.style.maxHeight === 'none') {
            // Collapse text
            textContent.style.maxHeight = '50px';
            textContent.innerHTML = truncateHtml(e.text, maxLength);
            showMoreLink.innerText = 'Show More';
          } else {
            // Expand text
            textContent.style.maxHeight = 'none';
            textContent.innerHTML = e.text;
            showMoreLink.innerText = 'Show Less';
          }
        });

        // Check if the text contains an <a> tag
        textContent.addEventListener('click', (event) => {
          const target = event.target as HTMLElement;
          if (target.tagName.toLowerCase() === 'a') {
            event.preventDefault();
            this.navigateLink(event, e)
          }
        });

      
    }
  }
  onExporting(e) {
    const pageName = this.localstorage.getObj('FILE EXPORT NAME');
    const currentDate = moment().format('YYYY-MM-DD');
    let fileName: string;
    if (pageName) {
      fileName = `${pageName} Versions ${currentDate}`;
    } else if (this.exportPageName) {
      fileName = `${this.exportPageName}-${currentDate}`;
      if (this.exportPageName === 'version') fileName = `${this.exportPageName}-${currentDate}`;
    } else {
      fileName = `Dynamic-Pages ${currentDate}`;
    }
    e.component.columnOption('Action', 'visible', false);
    if (e.format === 'pdf') {
      const doc = new jsPDF.jsPDF();
      exportDataGridToPdf({
        jsPDFDocument: doc,
        component: e.component,
        customizeCell: grid => {
          grid.pdfCell.wordWrapEnabled = true;
        }
      }).then(() => {
        doc.save(`${fileName}.pdf`);
        e.component.columnOption('Action', 'visible', true);
      });
    } else if (e.format === 'xlsx') {
      e.fileName = fileName;
      setTimeout(() => {
        e.component.columnOption('Action', 'visible', true);
      }, 500);
    }
  }

  islocked(grid, user) {
    if (grid.lock && user.locked) {
      return Number(user.lockedby) === Number(this.userId);
    } else {
      return true;
    }
  }
  getDateFormat(value: any) {
    if (this.registrationInfo) {
      if (value === 'date') {
        return this.registrationInfo['datetimeformat'].split(' ')[0];
      }
      return this.registrationInfo['datetimeformat'];
    }
    return 'MM/dd/yyyy';
  }

  isEnable(grid, record) {
    return grid.version && record.isEnable;
  }

  updateNotificationView(rowData) {
    const inputRequest = {
      isnew: false
    };
    const model = rowData?.data;
    this.mainNotificationService.updateNotification(model?.id, inputRequest).subscribe((_res: any) => {
      this.sharedService.sendMessage();
    });
  }
}
